import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import PlayCircleFilledRoundedIcon from "@mui/icons-material/PlayCircleFilledRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";

// Level 1 Videos (6 total)
const level1Videos = [
  { id: "4pKly2JojMw", title: "Breathing Yoga" },
  { id: "OQ6NfFIr2jw", title: "Sun Salutations" },
  { id: "v7AYKMP6rOE", title: "Basic Poses" },
  { id: "0t1w3GKRMsU", title: "Gentle Flow" },
  { id: "sTANio_2E0Q", title: "Core Strength" },
  { id: "VaoV1PrYft4", title: "Relax & Restore" },
];

// Step labels and lock status
const steps = [
  { label: "Level 1", unlocked: true },
  { label: "Level 2", unlocked: false },
  { label: "Level 3", unlocked: false },
  { label: "Level 4", unlocked: false },
  { label: "Level 5", unlocked: false },
  { label: "Level 6", unlocked: false },
  { label: "Level 7", unlocked: false },
];

const LevelsPage=()=> {
  const [activeStep, setActiveStep] = useState(0);

  const handleStepClick = (idx, unlocked) => {
    if (unlocked) setActiveStep(idx);
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <Box sx={{ maxWidth: "1300px", mx: "auto", pb:4}}>
    <Box sx={{ backgroundColor: "#f0f0f0"}}>
      <Typography variant="h4" sx={{ textAlign: "center", mb: 3, color: "#106870", pt: 8}}>
        Yoga Levels
      </Typography>

      {/* Custom Stepper with Outer-Connected Lines */}
      <Box sx={{ overflowX: "auto", pb: 4 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minWidth: 1000,
            position: "relative",
            mt: 4,
          }}
        >
          {steps.map((step, idx) => (
            <Box
              key={step.label}
              onClick={() => handleStepClick(idx, step.unlocked)}
              sx={{
                position: "relative",
                textAlign: "center",
                flex: 1,
                cursor: step.unlocked ? "pointer" : "default",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {/* Left line */}
              {idx > 0 && (
                <Box
                  sx={{
                    position: "absolute",
                    top: "24px",
                    left: 0,
                    width: "calc(50% - 25px)",
                    height: "3px",
                    backgroundColor: "#ccc",
                    zIndex: 0,
                  }}
                />
              )}

              {/* Right line */}
              {idx < steps.length - 1 && (
                <Box
                  sx={{
                    position: "absolute",
                    top: "24px",
                    right: 0,
                    width: "calc(50% - 25px)",
                    height: "3px",
                    backgroundColor: "#ccc",
                    zIndex: 0,
                  }}
                />
              )}

              {/* Circle */}
              <Box
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: "50%",
                  border: `3px solid ${step.unlocked ? "#3b7d5c" : "rgba(0,0,0,0.26)"}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#fff",
                  zIndex: 1,
                }}
              >
                {step.unlocked ? (
                  <PlayCircleFilledRoundedIcon sx={{ color: "#3b7d5c" }} />
                ) : (
                  <LockRoundedIcon sx={{ color: "rgba(0,0,0,0.26)" }} />
                )}
              </Box>

              {/* Label */}
              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                  fontWeight: 500,
                  color: step.unlocked ? "#3b7d5c" : "rgba(0,0,0,0.4)",
                }}
              >
                {step.label}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
      </Box>
      {/* Level Video Grid */}
      {activeStep === 0 ? (
        <Grid
          container
          spacing={4}
          justifyContent="center"
          sx={{ maxWidth: "1200px", mx: "auto", mt: 2 }}
        >
          {level1Videos.map((vid) => (
            <Grid item xs={12} sm={6} md={4} key={vid.id}>
  <Card
    sx={{
      width: { xs: "100%", sm: "100%", md: 320 },
      height: "auto", // Let content determine height
      mx: "auto",
      borderRadius: 0,
    }}
  >
    <CardContent sx={{ p: 2 }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: { xs: "100%", sm: 300, md: 300 },
          aspectRatio: "1 / 0.6", // ✅ Square shape
        //   paddingTop: "56.25%",
          overflow: "hidden",
          borderRadius: 2,
        }}
      >
        <iframe
          src={`https://www.youtube.com/embed/${vid.id}`}
          title={vid.title}
          allowFullScreen
          style={{
            width: "100%",
            height: "100%",
            border: 0,
          }}
        />
      </Box>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ textAlign: "center", mt: 1}}
      >
        {vid.title}
      </Typography>
    </CardContent>
  </Card>
</Grid>

          ))}
        </Grid>
      ) : (
        <Typography
          variant="h6"
          sx={{
            mt: 4,
            textAlign: "center",
            color: "text.secondary",
            fontWeight: 500,
          }}
        >
          🔒 This level is locked — keep practicing to unlock it!
        </Typography>
      )}
    </Box>
  );
}

export default LevelsPage